"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const gridHeight = {
    height: 'calc(100vh - 370px)'
};
const modalUploadContainer = theme => ({
    padding: 24,
    width: 'fit-content',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalHistoryContainer = theme => ({
    width: 997,
    padding: 24,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white
});
const modalLogsContainer = theme => ({
    width: 306,
    padding: 24,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white
});
const modalHeader = {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    alignItems: 'flex-start',
    marginBottom: 24
};
const modalHeaderTitle = theme => ({
    margin: 0,
    lineHeight: '24px',
    color: theme === 'dark' ? '#FFFFFF' : 'inherit'
});
const itemAdd = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20
};
const inputContainerItem = {
    width: 200
};
const inputItem = {
    height: 27,
    borderRadius: 5
};
const buttonSave = theme => ({
    padding: '0 5px',
    display: 'flex',
    fontSize: 'large',
    fontWeight: 'normal',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: constants_1.color.white,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'light' ? constants_1.color.redDark : constants_1.color.buttonDark,
    height: 40,
    width: 84,
    borderRadius: 10,
});
const buttonDelete = {
    padding: '0 5px',
    display: 'flex',
    fontSize: 'large',
    fontWeight: 'normal',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: constants_1.color.white,
    backgroundColor: constants_1.color.redDark,
    height: 35,
    width: 65,
    borderRadius: 10
};
const modalTitle = {
    margin: 0,
    fontSize: 20,
    lineHeight: '30px',
};
const modalSubtitle = {
    margin: 0,
    fontWeight: 400,
    lineHeight: '24px',
    color: constants_1.color.softGrey,
};
const dropdownStyle = theme => ({
    width: 100,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.borderGrey,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const gridCard = theme => ({
    padding: 24,
    marginTop: 24,
    borderRadius: 10,
    backgroundColor: theme === 'dark' ? constants_1.color.gridColumnDarkAlt : constants_1.color.white,
});
const dateButtonWrapper = {
    display: 'flex',
    marginBottom: 24,
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'space-between',
};
const textDate = theme => ({
    margin: 0,
    fontSize: 14,
    fontWeight: 400,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
});
const button = theme => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: 8,
    height: 40,
    padding: '12px 20px',
    backgroundColor: theme === 'light' ? constants_1.color.redDark : constants_1.color.buttonDark,
});
const buttonFont = {
    fontSize: '16px',
    fontWeight: 'normal',
    margin: 0,
    marginLeft: 8
};
const statusStyle = status => ({
    textAlign: 'center',
    color: status === 'Success' ? '#4C8C8C' : status === 'On Progress' ? '#FFC700' : '#BA352C'
});
const logTextStyle = {
    cursor: 'pointer',
    textAlign: 'center',
    textDecorationLine: 'underline'
};
exports.default = {
    button,
    itemAdd,
    textDate,
    gridCard,
    inputItem,
    gridHeight,
    modalTitle,
    buttonSave,
    buttonFont,
    modalHeader,
    statusStyle,
    buttonDelete,
    logTextStyle,
    modalSubtitle,
    dropdownStyle,
    modalHeaderTitle,
    dateButtonWrapper,
    inputContainerItem,
    modalLogsContainer,
    modalUploadContainer,
    modalHistoryContainer
};
